import React from 'react'
import PropTypes from 'prop-types'
import SDP from 'react-dates/lib/components/SingleDatePicker'

import NavPrev from './NavPrev'
import NavNext from './NavNext'
import { WEEK_DAY_FORMAT } from './constants'

/**
 * @see Take a look at [Airbnb's documentation](https://github.com/airbnb/react-dates#daterangepicker) for information on how to customise and configure this component.
 */
const SingleDatePicker = ({
  element,
  showKeyboardShortcutsPanel,
  ...props
}) => {
  const Element = element
  return (
    <Element className="ln-c-date-picker">
      <SDP
        navPrev={<NavPrev />}
        navNext={<NavNext />}
        weekDayFormat={WEEK_DAY_FORMAT}
        hideKeyboardShortcutsPanel={!showKeyboardShortcutsPanel}
        numberOfMonths={1}
        {...props}
      />
    </Element>
  )
}

SingleDatePicker.propTypes = {
  element: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.string,
  ]),
  showKeyboardShortcutsPanel: PropTypes.bool,
}

SingleDatePicker.defaultProps = {
  element: 'div',
  showKeyboardShortcutsPanel: false,
}

SingleDatePicker.displayName = 'SingleDatePicker'

export default SingleDatePicker
